let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aEov5")).then(() => parcelRequire('f1h86'));